export const TAILLE_PAGE = 25;
export const FILTRES = [
  { nom: "etablissement", label: "Établissement" },
  { nom: "organisation", label: "Organisation" },
  { nom: "ville", label: "Ville" },
  { nom: "zone", label: "Zone" },
  { nom: "stand", label: "Type de stand" },
  { nom: "statut", label: "Statut" },
] as const;

export const normaliser = (v: unknown): string => String(v ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("fr").trim();

// shortcut: filtrage en mémoire des listes déjà chargées, paginer l'API si leur volume dégrade le chargement.
export function filtrer<T extends { donnees: Readonly<Record<string, unknown>> }>(entites: readonly T[], recherche: string, filtres: Record<string, string>): T[] {
  const mots = normaliser(recherche).split(/\s+/).filter(Boolean);
  return entites.filter(({ donnees }) => {
    const texte = normaliser(Object.values(donnees).filter((v) => typeof v === "string" || typeof v === "number").join(" "));
    return mots.every((mot) => texte.includes(mot)) && Object.entries(filtres).every(([nom, valeur]) => !valeur || String(donnees[nom] ?? "") === valeur);
  });
}

export function paginer<T>(lignes: readonly T[], page: number): { lignes: readonly T[]; page: number; pages: number } {
  const pages = Math.max(1, Math.ceil(lignes.length / TAILLE_PAGE));
  const courante = Math.max(1, Math.min(page, pages));
  return { lignes: lignes.slice((courante - 1) * TAILLE_PAGE, courante * TAILLE_PAGE), page: courante, pages };
}
